import { createIndexedDBStorage } from 'zustand-indexeddb';
export var idbStorage = createIndexedDBStorage('loot-filters', 'store');
